import { c as _c } from "react/compiler-runtime";
import Icon from "@/components/icon";
interface PasswordToggleIconProps {
  showPassword: boolean;
  togglePasswordShow: () => void;
}
const PasswordToggleIcon: React.FC<PasswordToggleIconProps> = t0 => {
  const $ = _c(3);
  const {
    showPassword,
    togglePasswordShow
  } = t0;
  const t1 = showPassword ? "eye-hide" : "eye-show";
  let t2;
  if ($[0] !== t1 || $[1] !== togglePasswordShow) {
    t2 = <div className="w-12 flex justify-center items-center hover:cursor-pointer select-none"><Icon size={30} icon={t1} onClick={togglePasswordShow} /></div>;
    $[0] = t1;
    $[1] = togglePasswordShow;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default PasswordToggleIcon;